import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupResultsRoute extends Route 
{
	@service ajax
	
	bracketName = null
	
	resultsTimer = null
	configTimer = null
	
	resultsRefreshInterval = 10000
	configRefreshInterval = 60000
	
	async model(params) 
	{
		this.bracketName = params.bracket_name;
		
		const config = await this.fetchConfig();
		const results = await this.fetchResults(config);

		return {results:results,config:config};
	}
	
	setupController(controller, model) 
	{
	    controller.set('event', this.modelFor('event'));
		controller.set('bracketConfig',model.config);
		for(const result of model.results)
		{
			controller.set(result.name,result.data);
		}
	}
	
	async fetchResults(config=null)
	{
		let results = [];

		if(config == null)
		{
			if(this.controller == undefined)
			{
				return results;
			}
			config = this.controller.bracketConfig;
		}
		
		if(config)
		{
			const resultsFiles = config.results;
			for(const result of resultsFiles)
			{
				let data = await this.ajax.request(result.fileName);
				data = data.map(function(result)
				{
					return result.data.attributes;
				});
				results.push({name:result.name,data:data});
			}
		}
		return results;
	}
	
	async fetchConfig()
	{	
		let configs = await this.ajax.request("bracketConfig.json");
		let config = null;
		for(const bracket of configs)
		{
			if(bracket.name == this.bracketName)
				config = bracket;
		}
		return config
	}
	
	async fetchResultsLoop()
	{
		cancel(this.resultsTimer);
		this.resultsTimer = later(this,async function()
		{
			const results = await this.fetchResults();
			for(const result of results)
			{
				this.controller.set(result.name,result.data);
			}
			
			this.fetchResultsLoop();
		},this.resultsRefreshInterval);
	}
	
	async fetchConfigLoop()
	{
		cancel(this.configTimer);
		this.configTimer = later(this,async function()
		{
			const config = await this.fetchConfig();
			this.controller.set('screenConfig', config);
			
			this.fetchConfigLoop();
		},this.configRefreshInterval);
	}
	
	activate(transition)
	{
		this.fetchResultsLoop();
		this.fetchConfigLoop();
	}
	
	deactivate(transition)
	{
		cancel(this.resultsTimer);
		cancel(this.configTimer);
	}
}